<template>
  <div>
    <div class="filter-container" shadow="never">
      <el-form :inline="true">
      
        <el-form-item>
					<el-input v-model="searchData.goodsId" :placeholder='$i18n.t("common.ProductID1")' style="width: 180px;" class="filter-item" clearable ></el-input>
        </el-form-item>


        <el-form-item>
          <el-input v-model="searchData.idFuzzy" :placeholder='$i18n.t("common.SKU_EAN_Encoding")'  style="width: 180px;" class="filter-item" clearable  
              oninput="value=value.replace(/[%]/g,'')">
          </el-input>
        </el-form-item>

        <el-form-item>
					<el-select v-model="searchData.countryCodes" :multiple="true" clearable class="filter-item" style="width: 180px; margin-left: 10px" 
            :placeholder='$i18n.t("common.country")'>
						<el-option v-for="item in dictionary.country" :key="item.id" :label="item.name" :value="item.code"></el-option>      
					</el-select>
        </el-form-item>

        <el-form-item>
					<el-select v-model="searchData.userType" clearable class="filter-item" style="width: 180px; margin-left: 10px" :placeholder='$i18n.t("common.UserType")'>
						<el-option v-for="item in dictionary.goodsReservationUserType" :key="item.id" :label="item.name" :value="item.code"></el-option>      
					</el-select>
        </el-form-item>

        <el-form-item>
					<el-input v-model="searchData.email" :placeholder='$i18n.t("common.mailbox")' style="width: 180px;" class="filter-item" clearable ></el-input>
        </el-form-item>
        
 
        <el-form-item>
          <el-date-picker v-model="valuePicker" style="width: 100%" unlink-panels type='datetimerange'  :range-separator='$i18n.t("common.to")'
            :start-placeholder='$i18n.t("common.Creationtime")'  :end-placeholder='$i18n.t("common.Creationtime")' 
            :clearable="false"
            :default-time="['00:00:00','23:59:59']" >             
          
          </el-date-picker>
        </el-form-item>              
                            
                            
 
        <el-form-item>
            <el-button class="filter-item" icon="el-icon-search" type="primary" @click="handleSearchList" style="margin-left: 10px">
              {{ $i18n.t("common.query") }}
            </el-button>
            <el-button class="filter-item" icon="el-icon-search" type="primary" @click="handleResetSearch" style="margin-left: 10px" size="small">
              {{ $i18n.t("common.Reset") }}
            </el-button>

            <el-button class="filter-item" icon="el-icon-download" type="primary" @click="handleExport" style="margin-left: 10px" size="small"
               v-loading.fullscreen.lock="fullscreenExportLoading">
              {{ $i18n.t("common.export") }}
            </el-button>

        </el-form-item>
      </el-form>
    </div>     
        
 

    <el-table ref="pagedata" :data="pageData.list" border v-loading="loading"  style="width: 100%">

      <el-table-column prop="goodsId" :label="$t('common.ProductID')" align="center" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="goodsCode"  :label='$i18n.t("common.SKU_EAN_Encoding")' align="center" show-overflow-tooltip>
        <template slot-scope="scope">
                <span>SKU:{{ scope.row.sku }}</span><br />
                <span>EAN:{{ scope.row.barCode }}</span><br />
                <span>EAN-SUB:{{ scope.row.subBarCode }}</span><br />
                <span>{{ $t('common.coding') }}:{{ scope.row.goodsCode }}</span>
          </template>
      </el-table-column>
      <el-table-column prop="title" :label="$t('common.Productname1')" align="center" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="countryCode"  :label='$i18n.t("common.country")' align="center" show-overflow-tooltip>
          <template slot-scope="scope">
              {{ $dict.getDictValue('countrys',  scope.row.countryCode)  }}
          </template>
      </el-table-column>

      <el-table-column prop="userType"  :label='$i18n.t("common.UserType")' align="center" show-overflow-tooltip>
          <template slot-scope="scope">
              {{ $dict.getDictValue('goods_reservation_user_type',  scope.row.userType)  }}
          </template>
      </el-table-column>

      <el-table-column prop="email" :label="$t('common.Useremail')" align="center" show-overflow-tooltip> </el-table-column>


      <el-table-column prop="createTime" :label=' $i18n.t("common.Creationtime")' align="center"   :formatter="formatDate" show-overflow-tooltip></el-table-column>
     
 
    </el-table>



    <div class="block">
      <el-pagination @current-change="handleCurrentChange" :current-page="searchData.page"  
        :page-sizes="pageSizes"   @size-change="handleSizeChange"
        :page-size="searchData.limit" layout="total,sizes, prev, pager, next, jumper" :total="pageData.total">
      </el-pagination>
    </div>

 
    
  </div>
</template>
<script>

 
 
import moment from 'moment';


 
export default {
  components: {  moment },
  name: 'goodsReservation_module',
  data() {
    return {
      dictionary:{},
      fullscreenExportLoading: false,
      loading: false,
      valuePicker:[],
      //查询项
      searchData: {
        goodsId: '',
        idFuzzy: '',
        countryCodes:[],
        userType: '',
        email: '',
        beginTime: null,
        endTime: null,
        page: 1,
        limit: 10
      },
      defaultSearchData: {
        goodsId: '',
        idFuzzy: '',
        countryCodes:[],
        userType: '',
        email: '',
        beginTime: null,
        endTime: null,
        page: 1,
        limit: 10
      },
      pageSizes: [10, 20, 30, 50],
      pageData: {}
     
    };
  },
  created() {
    this.getDictItems();
  },
  mounted() {
    this.handleSearchList();
  },
  methods: {
    // 业务字典
    getDictItems() {
      this.$store.dispatch('getDicItems', { tag: 'countrys' }).then((res) => {    
          this.$set(this.dictionary,"country",res)
      }); 
      this.$store.dispatch('getDicItems', { tag: 'goods_reservation_user_type' }).then((res) => {    
          this.$set(this.dictionary,"goodsReservationUserType",res)
      });     
    },
    //搜索列表
    handleSearchList() {
      this.searchData.page = this.defaultSearchData.page
      this.searchData.limit = this.defaultSearchData.limit 
      this.loadlist();
    },
    //重置
    handleResetSearch() {
      this.valuePicker=[];
      this.searchData = Object.assign({}, this.defaultSearchData);
      this.handleSearchList();
    },
    // 点击页数查询
    handleCurrentChange(val) {
      this.searchData.page = val;
      this.loadlist();
    },
    // 点击条数查询
		handleSizeChange(val) {
      this.searchData.limit = val;
      this.loadlist();
    },
    loadlist(){

      if (this.valuePicker != null && this.valuePicker.length > 0) {

          this.searchData.beginTime = moment(this.valuePicker[0]).unix() * 1000;
          this.searchData.endTime = moment(this.valuePicker[1]).unix() * 1000;

      } else {
          this.searchData.beginTime = null;
          this.searchData.endTime = null;
      }
      

      this.loading=true
      let temp = JSON.stringify(this.searchData, (key, value) => {
        if (value !== null && value !== '') {
          return value;
        }
      });
      let curSates = JSON.parse(temp);
      this.$store.dispatch('getGoodsReservationPage', curSates).then(res => {
          this.pageData = res         
      }).finally(() => {
				this.loading = false;
			});
    },
     
    // 导出
    handleExport() {

      let temp = JSON.stringify(this.searchData, (key, value) => {
        if (value !== null && value !== '') {
          return value;
        }
      });
      let curSates = JSON.parse(temp);

      curSates.fileName = this.$i18n.t('common.ProductReservationList') + '.xlsx';

      this.$confirm(this.$i18n.t('common.Areyousuretoexportthefile'), this.$i18n.t('common.prompt'), {
          confirmButtonText: this.$i18n.t('common.confirm1'),
          cancelButtonText: this.$i18n.t('common.cancel'),
          type: 'warning'
      }).then(() => {
        this.fullscreenExportLoading = true;
        this.$store.dispatch('exportGoodsReservationExcel', curSates).then((res) => {
            this.$message({
                type: 'success',
                message: this.$i18n.t('common.Exportsuccessful')
            });
        }).finally(() => {
          this.fullscreenExportLoading = false;
        });
      }).catch(() => {
        
      });

    },  

    
    /**
    * 时间戳转码
    */
    formatDate(row, column) {
        // 获取单元格数据
        let data = row[column.property];
        if (!data) {
            return '';
        } else {
            return moment(data).format('YYYY-MM-DD HH:mm:ss');
        }
    }

        
  }
 
};

</script>


<style scoped>
.filter-container {
    padding: auto;
    margin-left: 20px;
    padding-top: 20px;
}


</style>